import React from 'react'

export default function Toastify(): JSX.Element {
  return <div>Error</div>
}
